import { redirectToOldFrontEnd } from 'src/boot/proxy'
import { RouteRecordRawArgumented } from 'src/types/route'

const module: RouteRecordRawArgumented = {
  path: 'bid-bot',
  name: 'bidBot',
  redirect: () => {
    redirectToOldFrontEnd('/bid-bot/list')
    return { name: 'Home' }
  },
}

export default module
